import React from "react";
import { AlertInLine } from "../../../AlertInLine";
import { type WagerCardNotificationProps } from "../../types";

const WagerCardNotification = ({
  scratchedLegText,
  scratchedTitle,
  shouldNotHideScratchNotification,
  showScratchedNotification,
  onDismissPress,
  wagerId,
  onNotificationPress,
  enableMyBetsBehavior
}: WagerCardNotificationProps) =>
  showScratchedNotification && shouldNotHideScratchNotification ? (
    <AlertInLine
      message={scratchedLegText}
      title={scratchedTitle}
      type="fixed"
      variant={
        scratchedTitle.includes("Scratch") && enableMyBetsBehavior
          ? "warning"
          : "informational"
      }
      qaLabel={`notification-scratch-${wagerId}`}
      marginBottom="space-5"
      onDismissPress={() => onDismissPress(false)}
      linkLabel="See Rules"
      onClick={onNotificationPress}
    />
  ) : null;

export default WagerCardNotification;
